module.exports = __webpack_public_path__ + "img/4684.6df1406d.jpg";